import { Button } from "@material-tailwind/react";
import { Backdrop, Box, Fade, Modal } from "@mui/material";
import React from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import ReactSelect from "react-select";

function AddBranch(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: "40px",
    outline: "none",
    borderRadius: "35px",
    // overflowX: "scroll",
    maxHeight: "90vh",
    overflowY: "scroll",
  };

  const colorStyles = {
    control: (styles) => ({
      ...styles,
      border: "none",
      marginBottom: "0",
      marginTop: "0",
      outline: "none",
      padding: "16px 20px",
      borderRadius: "1rem",
      boxShadow: "none",
      background: "#F5F7F9",
      color: "#BDBDBD",
      "&:hover": {
        border: "none",
      },
    }),
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open}
        // onClose={props.onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <div className="flex justify-between items-center">
              <p className="font-bold text-4xl text-black">
                {props.modal?.update ? "Update" : props.modal?.add ? "Add" : ""}{" "}
                Branch
              </p>
              <IoClose
                className="cursor-pointer border border-[#BDBDBD] rounded-full absolute right-6 top-8 text-[#BDBDBD]"
                onClick={props.onClose}
              />
            </div>
            <form
              onSubmit={
                props.modal?.update
                  ? props.handleUpdateSubmit
                  : props.handleAddSubmit
              }
              className="mt-3 w-[300px] sm:w-[400px] flex flex-col gap-3"
            >
              {props.modal.add && (
                <ReactSelect
                  value={props.fieldData?.headbranch}
                  onChange={(e) =>
                    props.setFieldData({ ...props.fieldData, headbranch: e })
                  }
                  options={props.headOfficeList?.map((item) => {
                    return {
                      value: item._id,
                      label: item.name,
                    };
                  })}
                  className="custom-select"
                  placeholder="Select a Head Office... *"
                  styles={colorStyles}
                  required
                />
              )}
              <input
                className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                type="text"
                name="name"
                placeholder="Name *"
                onChange={props.handleChange}
                value={props.fieldData?.name}
                required
              />
              <input
                className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f] custom-number-input"
                type="tel"
                name="phone"
                placeholder="Phone no. *"
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                  props.handleChange({ target: { name: "phone", value } }); // Updates the value with numbers only
                }}
                value={props.fieldData?.phone}
                maxLength={10}
                required
              />
              <input
                className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                type="email"
                name="email"
                placeholder="Email ID *"
                onChange={props.handleChange}
                value={props.fieldData?.email}
                required
              />
              <div>
                <label className="text-sm pb-4 font-medium">
                  Opening Time *
                </label>
                <input
                  className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                  type="time"
                  name="open"
                  placeholder="Opening Time *"
                  onChange={props.handleChange}
                  value={props.fieldData?.open}
                  required
                />
              </div>
              <div>
                <label className="text-sm pb-4 font-medium">
                  Closing Time *
                </label>
                <input
                  className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                  type="time"
                  name="close"
                  placeholder="Closing time *"
                  onChange={props.handleChange}
                  value={props.fieldData?.close}
                  required
                />
              </div>

              {props.modal.add && (
                <div className="relative">
                  <input
                    className="w-full bg-[#F5F7F9] pl-7 pr-12 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                    type={props.isPasswordVisible ? "text" : "password"}
                    name="password"
                    placeholder="Password *"
                    onChange={props.handleChange}
                    value={props.fieldData?.password}
                    required
                  />
                  {props.isPasswordVisible ? (
                    <FiEyeOff
                      onClick={props.togglePasswordVisibility}
                      className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
                    />
                  ) : (
                    <FiEye
                      onClick={props.togglePasswordVisibility}
                      className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
                    />
                  )}
                </div>
              )}
              <Button
                type="submit"
                disabled={props.loading?.btn}
                className="mt-2 rounded-2xl bg-[#03438D] px-7 py-6 tracking-widest font-poppins font-light text-lg outline-none"
              >
                {props.loading?.btn ? "Loading..." : "Continue"}
              </Button>
            </form>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default AddBranch;
